import { createContext, useState } from "react";

export const SpecializeContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    const [specializes, setSpecializes] = useState([]);

    // Make the context object:
    const specializeContext = {
        specializes,
        setSpecializes,
    };

    // pass the value in provider and return
    return <SpecializeContext.Provider value={specializeContext}>{children}</SpecializeContext.Provider>;
};

export const { Consumer } = SpecializeContext;
